import { getData, createQueryString, addSessionParams } from '../utils/HelperFunctions.js';
import GoogleAnalytics from '../utils/GoogleAnalytics.js';
import { openPopUpWindow, sleep } from '../utils/CommonFunctions.js';

// Set window location to force download file (headers set by endpoint)
export const getQWC = paramsObject => {
    let url = createQueryString(paramsObject, 'sync/qwc_download');
    window.location = url;
};

export const onlineSync = (paramsObject = {}) => {
    GoogleAnalytics.QBO('Sync');
    paramsObject.async = 1;
    let pollCount = 0;
    const poll = res => {
        if (!res.poll) {
            return res;
        }
        return sleep(5).then(() => {
            return getData({ count: ++pollCount }, 'sync/online_sync_poll').then(poll);
        });
    };
    return getData(paramsObject, 'sync/online_sync').then(poll);
};

export const qbConnect = (paramsObject = {}) => {
    GoogleAnalytics.QBO('Connect');
    // The popup is a plain page load, not a fetch, so it must carry the login
    // itself (M7-555: the backend now requires one). Same as every other request.
    let url = createQueryString(addSessionParams({ ...paramsObject }), 'sync/qb_connect');
    let qbConnectWindow = openPopUpWindow('QuickBooks Online', 800, 700, url);
    // Reload the current sync page so OAuth is tested
    var timer = setInterval(() => {
        if (qbConnectWindow.closed) {
            clearInterval(timer);
            window.location.reload();
        }
    }, 1000);
};

export const isOauthValid = (paramsObject = {}) => {
    return getData(paramsObject, 'sync/oauth_valid').then(res => res);
};

export const qbDisconnect = (paramsObject = {}) => {
    return getData(paramsObject, 'sync/qb_disconnect').then(res => res);
};
